import type { Statement } from "../../api/types";
import { t } from "../../i18n";
import { formatEuro } from "../../lib/money";
import { formatTime } from "../../lib/time";

/**
 * "Cash" (prototype dienst): what the courier delivered and did not settle yet, the cash to hand over and
 * what came in with the bank-QR; settling is done at the till with the code of a manager or the owner.
 */
export function CashView({ statement }: { statement: Statement | null }) {
  const text = t.tafoApp.courier;
  return (
    <>
      <div className="kvs">
        <div>
          <span>{text.deliveredUnsettled}</span>
          <b>{statement?.orderIds.length ?? 0}</b>
        </div>
        <div>
          <span>{text.cashToHand}</span>
          <b className="num">{formatEuro(statement?.cashCents ?? 0)}</b>
        </div>
        <div>
          <span>{text.qrReceived}</span>
          <b className="num">{formatEuro(statement?.qrCents ?? 0)}</b>
        </div>
      </div>
      {statement?.lines.map((line, index) => (
        <div className="ph-card" key={`${line.orderId}:${String(index)}`}>
          <div>
            <b>
              {line.code} · {formatTime(line.deliveredAt)}
            </b>
            <span className="proto">{line.address}</span>
            <span>
              {line.methods.map((method) => t.paymentMethods[method]).join(" + ")} · {formatEuro(line.amountCents)}
            </span>
          </div>
        </div>
      ))}
      <p className="proto">{text.cashNote}</p>
    </>
  );
}
